module.exports = __webpack_public_path__ + "static/img/gpt52.0e49f9d9.jpg";